import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import Check from "components/helpers/check";
import {displayDateTime} from "lib/ext/string";
import {useDelete} from "lib/hooks/use-pagination";

function Row({record}) {
  const onDelete = useDelete({check: "Are you sure you want to delete this tag?", record});

  return (
    <tr>
      <td><Check checked={record.active} /></td>
      <td>{record.name}</td>
      <td>{record.coordinator ? record.coordinator.name : "None"}</td>
      <td>{record.candidate_count}</td>
      <td>{record.rank}</td>
      <td>{displayDateTime(record.created_at)}</td>
      <td>
        <div className="btn-group" role="group" aria-label="Actions">
          <Link className="btn btn-sm btn-blue" to={`/admin/tags/${record.id}`}>Edit</Link>
          <button type="button" className="btn btn-sm btn-red" onClick={onDelete}>Destroy</button>
        </div>
      </td>
    </tr>
  );
}

Row.propTypes = {
  record: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    candidate_count: PropTypes.number.isRequired,
    coordinator: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    created_at: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired
  }).isRequired
};

export default Row;
